/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressBarIndicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function ProgressBarIndicator({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Progress/Content/ProgressBarIndicator"
  
}) {
  let isBefore = useIsBefore()
let selectedFlowQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'flowQuestions',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData = fromHelpers.getCurrentProgress(selectedFlowQuestionsValueData, selectedAnswersValueData)
let dtProgressbarindicatorBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ProgressBarIndicator.backgroundColor.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="ProgressBarIndicator.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1LLDQt': dtProgressbarindicatorBackgroundcolorPrimaryBase,'--sb-2-Z1LLDQt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--soy-3-Z1LLDQt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--w-4-Z1LLDQt': typeof aggregateData === 'number' ? `${aggregateData}px` : aggregateData,'--o-5-Z1LLDQt': isBefore ? 0 : 1}}
 className={`views-block ${styles.Horizontal}`}
/>
{children}
</React.Fragment>)
}